import { LazyModule, LazyAction } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "MailAccountsStore"*/ './lazyIndex')
);

// Actions
export const lazyAddAccount = new LazyAction(lazyModule, m => m.addAccount);
export const lazyRemoveAccountById = new LazyAction(lazyModule, m => m.removeAccountById);
export const lazySetSelectedAccount = new LazyAction(lazyModule, m => m.setSelectedAccount);
export { default as onSelectedAccountChanged } from './actions/onSelectedAccountChanged';

// Schema
export type { default as Provider } from './store/schema/Provider';

// Store
export { default as getProfileStore } from './store/profileStore';

// Utils
export { getAccountIdByEmailAddress } from './utils/getAccountIdByEmailAddress';
export { getAccountEmailAddressById } from './utils/getAccountEmailAddressById';
export { getIconFromAccountType } from './utils/getIconFromAccountType';

// Selectors
export { getMailboxSources } from './selectors/getMailboxSources';
export { getStoreLoadingState, StoreLoadingState } from './selectors/getStoreLoadingState';
export { getSelectedAccount } from './selectors/getSelectedAccount';
export { getAccountSourceById } from './selectors/getAccountSourceById';

// GraphQL
export { AccountSourceListDocument } from './graphql/__generated__/AccountSourceListQuery.interface';

// Register mutators
import './mutators/setSelectedAccountMutator';
import './mutators/addAccountMutator';

// Register orchestrators
import './orchestrators/removeAccountOrchestrator';
